import React from "react";
import { ChevronRight } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconChevronRight({ className, size = 12 }: Props) {
  return <ChevronRight className={className} width={size} height={size} />;
}


